import { DesignLayoutType, EventPageFragment, EventPageType } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useMemo } from 'react';

type UseGetGuestSitePages = Readonly<{
  pages: readonly EventPageFragment[];
}>;

// Filtering logic moved from BE to FE to avoid presentational logic on BE
export const useGetGuestSitePages = ({ pages = [] }: Partial<UseGetGuestSitePages>): UseGetGuestSitePages => {
  const { eventInfo } = useEventInfo();

  const currentPages = useMemo(() => {
    if (!eventInfo) {
      return [];
    }

    const { qanda, layoutType, story } = eventInfo;

    const tidbitsExist = qanda?.length && qanda.length > 0;
    const storyExists = !!story;
    let currentPages = pages;

    if (layoutType === DesignLayoutType.brannan && !tidbitsExist && !storyExists) {
      currentPages = currentPages.filter(page => page.type !== EventPageType.story);
    }

    if (layoutType === DesignLayoutType.aloha) {
      if (!tidbitsExist) {
        currentPages = currentPages.filter(page => page.type !== EventPageType.tidbits);
      }

      if (!storyExists) {
        currentPages = currentPages.filter(page => page.type !== EventPageType.story);
      }
    }

    return currentPages;
  }, [eventInfo, pages]);

  return {
    pages: [...currentPages],
  };
};
